module.exports = __webpack_public_path__ + "img/05.1e568bea.png";